<template>
    <div class="card-body">

        <PageHeader v-if="showHeading" title="Upcoming Invoice" class="poppins fw-normal mt-2" />

        <div v-if="!invoice && !processing" class="text-center">
            No upcoming invoice found.
        </div>

        <div v-if="processing" class="text-center">
            <i class="fas fa-spinner fa-spin"></i>
        </div>

        <div v-if="invoice && !processing" class="mt-3">

            <div class="border rounded">

                <div class="row fw-semibold border-bottom py-2 px-3">
                    <div class="col-md-6">Description</div>
                    <div class="col-md-2 text-end">Qty</div>
                    <div class="col-md-2 text-end">Unit price</div>
                    <div class="col-md-2 text-end">Amount</div>
                </div>

                <div v-for="line in invoice?.lines?.data" :key="line.id"
                    class="row py-3 px-3 border-bottom align-items-center">
                    <div class="col-md-6">
                        <div class="fw-semibold">
                            {{ line.price?.nickname || 'Subscription' }}
                        </div>
                        <small class="text-muted">
                            {{ formatDate(line.period.start) }} – {{ formatDate(line.period.end) }}
                        </small>
                    </div>

                    <div class="col-md-2 text-end">
                        {{ line.quantity }}
                    </div>

                    <div class="col-md-2 text-end">
                        {{ formatAmount(line.price?.unit_amount) }}
                    </div>

                    <div class="col-md-2 text-end">
                        {{ formatAmount(line.amount) }}
                    </div>
                </div>
            </div>

            <div class="row justify-content-end mt-3">
                <div class="col-md-4">

                    <div class="d-flex justify-content-between py-1">
                        <span>Scheduled Payment Date:</span>
                        <span>{{ formatDate(invoice.next_payment_attempt) }}</span>
                    </div>

                    <div class="d-flex justify-content-between py-1">
                        <span>Subtotal</span>
                        <span>{{ formatAmount(invoice.subtotal) }}</span>
                    </div>

                    <div class="d-flex justify-content-between py-1">
                        <span>Total excluding tax</span>
                        <span>{{ formatAmount(invoice.total_excluding_tax) }}</span>
                    </div>

                    <div class="d-flex justify-content-between py-1">
                        <span>Tax</span>
                        <span>—</span>
                    </div>

                    <hr />

                    <div class="d-flex justify-content-between fw-semibold py-1">
                        <span>Total</span>
                        <span>{{ formatAmount(invoice.total) }}</span>
                    </div>

                    <div class="d-flex justify-content-between omaha-primary-text py-1">
                        <span>Amount Paid</span>
                        <span>-{{ formatAmount(invoice.amount_paid || 0) }}</span>
                    </div>

                    <div class="d-flex justify-content-between fw-semibold py-1">
                        <span>Amount remaining</span>
                        <span>{{ formatAmount(invoice.amount_remaining) }}</span>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<script>
import PageHeader from "@/components/static/page-header";

export default {
  name: "UserUpcomingInvoice",

  components: { PageHeader },

  props: {
    user: { type: Object, required: true },
    showHeading: { type: Boolean, default: true }
  },

  data() {
    return {
      invoice: null,
      processing: false
    };
  },

  mounted() {
    this.fetchUpcomingInvoice();
  },

  methods: {
    fetchUpcomingInvoice() {
      this.processing = true;
      this.$axios
        .get("payments/user-upcoming-invoice", {
          params: { user_id: this.user.id }
        })
        .then(res => {
          this.invoice = res?.data?.data?.invoice || null;
        })
        .catch(() => {
          this.invoice = null;
        })
        .finally(() => {
          this.processing = false;
        });
    },

    formatAmount(amount = 0) {
      return `$${(amount / 100).toFixed(2)}`;
    },

    formatDate(ts) {
      return ts
        ? new Date(ts * 1000).toLocaleDateString()
        : "—";
    },

  }
};
</script>
<style scoped>
hr {
    margin: 0.75rem 0;
}
</style>